/**
 * Created by felipe on 7/22/24.
 */
'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('quizzingReportInstructor', {
                parent: 'site',
                url: '/quizzing/:collectionId/:assetId/:quizId/instructor/report',
                params: {
                },
                data: {
                    roles: [],
                    pageTitle: 'quizzing.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/quizzing/templates/quizzing-instructor-report.html',
                        controller: 'QuizzingInstructorReportController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('quizzing');
                        return $translate.refresh();
                    }]
                }
            });
    });
